import {useEffect, useState} from "react";
import golden_star from "../assets/golden_star.png"
import hollow_star from "../assets/hollow_star.png"

const ROICoachPerformance = (props) => {

    const generatingReport = props.generatingReport;
    const [data, setData] = useState(null);
    const stars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    const teams = Array.isArray(props.teams) ? props.teams : [];

    useEffect(() => {
        setData(props.data ?? null);
    }, [props.data]);

    const teamScore = (v) => (typeof v === "number" ? v : 0);

    return (
        <div className="roi-coach-performance-container">
            <div
                className="roi-coach-performance-title-container"
                style={{ borderRadius: generatingReport ? "unset" : null }}
            >
                Coach Performance Summary
            </div>

            {teams.length > 0 ? (
                <div className="roi-coach-performance-body-container">
                    <div className="roi-coach-performance-body-row">
                        <div className="roi-coach-performance-body-text">
                            The following scores are the aggregated feedback scores you have
                            received from team participants, as rated at the end of the
                            coaching engagement, for all teams selected for this report.
                        </div>
                        <div className="roi-coach-performance-body-graphic">
                            <div className="roi-coach-performance-participants-asked bold">
                                <div className="roi-coach-performance-participants-asked-text">
                                    Participants Asked
                                </div>
                                <div className="roi-coach-performance-participants-asked-spacer" />
                                <div className="roi-coach-performance-participants-asked-text value">
                                    {data?.participants_asked ?? "-"}
                                </div>
                            </div>
                        </div>
                    </div>

                    {data ? (
                        <>
                            {/* Q1 */}
                            <div className="roi-coach-performance-body-row">
                                <div className="roi-coach-performance-number-container">1.</div>
                                <div className="roi-coach-performance-body-text thin regular">
                                    The Team Coach(es) positively influenced the communication and
                                    effectiveness <b className="bold">of the team as a whole</b>?
                                </div>
                                <div className="roi-coach-performance-rating-container">
                                    <div className="roi-coach-performance-rating-headings-container">
                                        <div className="roi-coach-performance-rating-heading">
                                            Lowest
                                        </div>
                                        <div className="roi-coach-performance-rating-heading">
                                            Highest
                                        </div>
                                    </div>
                                    <div className="roi-coach-performance-stars-container">
                                        {stars.map((star, idx) => (
                                            <div
                                                key={idx}
                                                className={
                                                    idx === 0
                                                        ? "roi-coach-performance-star-column-container start"
                                                        : idx === 9
                                                            ? "roi-coach-performance-star-column-container end"
                                                            : "roi-coach-performance-star-column-container"
                                                }
                                            >
                                                <img
                                                    src={
                                                        teamScore(data.team_improvement) >= star
                                                            ? golden_star
                                                            : hollow_star
                                                    }
                                                    alt="star"
                                                />
                                                <div className="roi-star-text">{star}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Q2 */}
                            <div className="roi-coach-performance-body-row">
                                <div className="roi-coach-performance-number-container">2.</div>
                                <div className="roi-coach-performance-body-text thin regular">
                                    The Team Coach(es) positively influenced the communication and
                                    effectiveness of <b className="bold">you personally</b> within
                                    this team?
                                </div>
                                <div className="roi-coach-performance-rating-container">
                                    <div className="roi-coach-performance-rating-headings-container">
                                        <div className="roi-coach-performance-rating-heading">
                                            Lowest
                                        </div>
                                        <div className="roi-coach-performance-rating-heading">
                                            Highest
                                        </div>
                                    </div>
                                    <div className="roi-coach-performance-stars-container">
                                        {stars.map((star, idx) => (
                                            <div
                                                key={idx}
                                                className={
                                                    idx === 0
                                                        ? "roi-coach-performance-star-column-container start"
                                                        : idx === 9
                                                            ? "roi-coach-performance-star-column-container end"
                                                            : "roi-coach-performance-star-column-container"
                                                }
                                            >
                                                <img
                                                    src={
                                                        teamScore(data.personal_improvement) >= star
                                                            ? golden_star
                                                            : hollow_star
                                                    }
                                                    alt="star"
                                                />
                                                <div className="roi-star-text">{star}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Q3 */}
                            <div className="roi-coach-performance-body-row">
                                <div className="roi-coach-performance-number-container">3.</div>
                                <div className="roi-coach-performance-body-text thin regular">
                                    I would recommend this Team Coach(es) to another team?
                                </div>
                                <div className="roi-coach-performance-rating-container">
                                    <div className="roi-coach-performance-rating-headings-container">
                                        <div className="roi-coach-performance-rating-heading">
                                            Lowest
                                        </div>
                                        <div className="roi-coach-performance-rating-heading">
                                            Highest
                                        </div>
                                    </div>
                                    <div className="roi-coach-performance-stars-container">
                                        {stars.map((star, idx) => (
                                            <div
                                                key={idx}
                                                className={
                                                    idx === 0
                                                        ? "roi-coach-performance-star-column-container start"
                                                        : idx === 9
                                                            ? "roi-coach-performance-star-column-container end"
                                                            : "roi-coach-performance-star-column-container"
                                                }
                                            >
                                                <img
                                                    src={
                                                        teamScore(data.recommend) >= star
                                                            ? golden_star
                                                            : hollow_star
                                                    }
                                                    alt="star"
                                                />
                                                <div className="roi-star-text">{star}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
            ) : (
                <div className="roi-report-title-card-no-teams">No teams selected</div>
            )}
        </div>
    );
};

export default ROICoachPerformance;
